
const newModel = () => {
    return {
        khachSanId: null,
        ten: null,
        tenTat: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tieuchuanKhachsanId: null,
        tenTieuchuanKhachsan: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        ghiChu: null,
        web: null,
        tongsoPhong: null,
        phongDon: null,
        phongDoi: null,
        phongGiadinh: null,
        soLeu: null,
        sucChua: null,
        giayDangKy: null,
        ngayCapGdk: null,
        stt: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        khachSanId: null,
        ten: null,
        tenTat: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tieuchuanKhachsanId: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        tongsoPhong: null,
        phongDon: null,
        phongDoi: null,
        phongGiadinh: null,
        soLeu: null,
        sucChua: null,
        giayDangKy: null,
        ngayCapGdk: null,
        gioiThieu: null,
        ghiChu: null,
        web: null,
        stt: "0",
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: true
    }
}

const fromJson = (item) => {
    return {
        khachSanId: item.khachSanId,
        ten: item.ten,
        tenTat: item.tenTat,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        tieuchuanKhachsanId: item.tieuchuanKhachsanId,
        tenTieuchuanKhachsan: item.tenTieuchuanKhachsan,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioiThieu: item.gioiThieu,
        ghiChu: item.ghiChu,
        web: item.web,
        stt: item.stt,
        tongsoPhong: item.tongsoPhong,
        phongDon: item.phongDon,
        phongDoi: item.phongDoi,
        phongGiadinh: item.phongGiadinh,
        soLeu: item.soLeu,
        sucChua: item.sucChua,
        giayDangKy: item.giayDangKy,
        ngayCapGdk: item.ngayCapGdk,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        khachSanId: item.khachSanId,
        ten: item.ten,
        tenTat: item.tenTat,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        tieuchuanKhachsanId: item.tieuchuanKhachsanId,
        tenTieuchuanKhachsan: item.tenTieuchuanKhachsan,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        tongsoPhong: item.tongsoPhong,
        phongDon: item.phongDon,
        phongDoi: item.phongDoi,
        phongGiadinh: item.phongGiadinh,
        soLeu: item.soLeu,
        sucChua: item.sucChua,
        giayDangKy: item.giayDangKy,
        ngayCapGdk: item.ngayCapGdk,
        gioiThieu: item.gioiThieu,
        ghiChu: item.ghiChu,
        web: item.web,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        tieuchuanKhachsanId: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        tieuchuanKhachsanId: item.tieuchuanKhachsanId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        khachSanId: null,
        ten: null,
        tenTat: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tieuchuanKhachsanId: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        tongsoPhong: null,
        phongDon: null,
        phongDoi: null,
        phongGiadinh: null,
        soLeu: null,
        sucChua: null,
        giayDangKy: null,
        ngayCapGdk: null,
        sdt: null,
        gioiThieu: null,
        ghiChu: null,
        web: null,
        stt: null,
        enabled: null,
    }
}

export const khachSanModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


